import { useAuthorization } from 'components/Authorization';
import { isAeProduct } from 'productLine';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import chatttSDK from 'services/chattt';
import { selectAtom } from 'jotai/utils';

export const orgConfigState = atom<General.OrgConfig>({
  remindEnable: false,
  kageEnable: false,
  refundEnable: false,
  reviewEnable: false,
  qaItemEnable: import.meta.env.VITE_ENV === 'staging' || import.meta.env.VITE_ENV === 'feature',
  airwallexEnable: true,
  robotIndependentEnable: false,
  perfNavEnable: false,
  xiapibuyEnable: undefined,
  shopeeImageDomainScoreEnable: (chatttSDK?.app?.getLocaleCountryCode() || 'CN') === 'CN',
  shopeeImageReportAllEnable: false,
  qaEnable: false,
  isDoneFirstConfigBootstrap: false,
});

export const useOrgConfigStateValue = () => {
  return useAtomValue(orgConfigState);
};

export const useSetOrgConfigStateValue = () => {
  return useSetAtom(orgConfigState);
};

const orgConfigQAEnableState = selectAtom(orgConfigState, (config) => config.qaEnable);

export const useOrgConfigQAEnable = () => useAtomValue(orgConfigQAEnableState);

export const orgConfigNewUIV2EnableState = selectAtom(
  orgConfigState,
  (config) => config?.whiteListConfig?.UIV2 ?? false,
);

export const orgConfigTradeOverThreeMonthEnableState = selectAtom(
  orgConfigState,
  (config) => config?.whiteListConfig?.TRADE_OVER_THREE_MONTH ?? false,
);

const lechatAgentEnableState = selectAtom(
  orgConfigState,
  (config) => config?.whiteListConfig?.LECHAT_AGENT_LIST ?? false,
);

export const useNewUIV2Enable = () => useAtomValue(orgConfigNewUIV2EnableState);

export const useTradeOverThreeMonthEnable = () => {
  return useAtomValue(orgConfigTradeOverThreeMonthEnableState);
};

export const useLechatAgentEnable = () => useAtomValue(lechatAgentEnableState);

export const useNonPlatformQaEnable = () => {
  const { whiteListConfig: { QA_MIXED_PLATFORM = false } = {} } = useOrgConfigStateValue();

  const { payload } = useAuthorization<Oversea.Token.Payload>();

  if (isAeProduct) {
    return false;
  }

  const { orgId = 0 } = payload || {};

  if (orgId >= 13941) {
    return true;
  }

  return QA_MIXED_PLATFORM;
};
